export enum ProviderEnum {
  MON_PETIT_PLACEMENT = '/v1/providers/1edc4d1a-4346-6294-989b-5df7b950fc1a',
  GENERALI = '/v1/providers/1edc4d1a-4ce4-6a80-908a-5df7b950fc1a',
  APICIL = '/v1/providers/1edc4d1a-5670-69f0-8027-5df7b950fc1a',
  LAFRANCEMUTUALISTE = '/v1/providers/018c1060-2a5d-7939-8f86-84e8958edfa9'
}
